export const SET_PERSONAL_CONFIGURATION = 'SET_PERSONAL_CONFIGURATION';
export const SET_GLOBAL_PERIOD = 'SET_GLOBAL_PERIOD';

export const setPersonalConfiguration = (payload) => ({
  type: SET_PERSONAL_CONFIGURATION,
  payload
});

export const setGlobalPeriod = (payload) => ({
  type: SET_GLOBAL_PERIOD,
  payload
});